/**
 * 工具箱类
 * @param _tools
 * @returns
 */
(function (_tools) {
	Tools = {};
	let mapLayers;
	//画线
	Tools.drawLines = function (_mapLayers, _style, callback) {
			mapLayers = _mapLayers
			if (!_mapLayers)
				return;
			var that = this;
			that._mapLayers = _mapLayers;
			if (that.linesObj)
				Tools.removeLines(that.linesObj, _mapLayers), that.linesObj = [];
			else
				that.linesObj = [];
			that.line = [];
			that.mouseup = CEvent.addListener(_mapLayers, 'mouseup', function (e) {
				that.line.push(e.latlng);
				if (that.line.length > 1)
					that.linesObj.push(Tools.drawLine(that.line[that.line.length - 2], e.latlng, _style));
				if (!that.lineMousemove)
					that.lineMousemove = CEvent.addListener(_mapLayers, 'mousemove', function (e) {
						if (that.mousemoveline)
							_mapLayers.removeOverlay(that.mousemoveline);
						if (that.line.length != 0)
							that.mousemoveline = Tools.drawLine(that.line[that.line.length - 1], e.latlng, _style);
					});
				if (that.mousemoveline)
					_mapLayers.removeOverlay(that.mousemoveline);
			});
			that.singlerightclick = CEvent.addListener(_mapLayers, 'singlerightclick', function (e) {
				CEvent.removeListener(that.mouseup), CEvent.removeListener(that.lineMousemove), CEvent.removeListener(that.singlerightclick);
				that.mouseup = null, that.lineMousemove = null;
				if (callback)
					callback(that.line, that.linesObj);
			})
		},
		Tools.drawLine = function (startlatlng, endlatlng, opts) {
			if (!opts)
				opts = {
					color: '#c45366',
					weight: 3,
					opacity: 0.9
				};
			polyline = mapLayers.drawPolyline([startlatlng, endlatlng], opts);
			if (opts.title)
				polyline.bindTooltip(opts.title);
			return polyline;
		},
		Tools.removeLines = function (_arr, _mapLayers) {
			_arr.forEach(function (e) {
				_mapLayers.removeOverlay(e);
			});
		},
		//画矩形
		Tools.drawRectangle = function (_mapLayers, _style, callback) {
			var that = this;
			_mapLayers.dragging.disable();
			if (that.rectangle)
				Tools.removeRectangles(_mapLayers, that.rectangle)
			that.rectangleMousedown = CEvent.addListener(_mapLayers, 'mousedown', function (e) {
				that.startPoi = e.latlng;
				that.rectangleMousemove = CEvent.addListener(_mapLayers, 'mousemove', function (e) {
					if (that.rectangle)
						_mapLayers.removeOverlay(that.rectangle)
					that.endPoi = e.latlng;
					that.rectangle = Tools.drawRectangles(that.startPoi, that.endPoi, _mapLayers, _style);
				});
			});
			that.rectangleMouseup = CEvent.addListener(_mapLayers, 'mouseup', function (e) {
				that.rectangle;
				CEvent.removeListener(that.rectangleMouseup), CEvent.removeListener(that.rectangleMousedown), CEvent.removeListener(that.rectangleMousemove);
				_mapLayers.dragging.enable();
				if (callback)
					callback(that.rectangle._latlngs, that.rectangle);
			});
		},
		Tools.drawRectangles = function (startPoi, endPoi, _mapLayers, _style) {
			var bounds = new CLatLngBounds(startPoi, endPoi);
			var opts = {
				color: '#c45366',
				weight: 2,
				opacity: 0.9,
				fill: true,
				fillColor: '#009900',
				fillOpacity: 0.4
			};
			if (_style)
				opts = _style;
			feature = _mapLayers.drawRectangle(bounds, opts);
			return feature;
		},
		Tools.removeRectangles = function (_mapLayers, _layer) {
			_mapLayers.removeOverlay(_layer);
		},
		//画圆
		Tools.drawCircle = function (_mapLayers, _style, callback) {
			var that = this;
			_mapLayers.dragging.disable();
			if (that.rectangle)
				Tools.removeCircles(_mapLayers, that.rectangle)
			that.circleMousedown = CEvent.addListener(_mapLayers, 'mousedown', function (e) {
				that.startPoi = e.latlng;
				that.circleMousemove = CEvent.addListener(_mapLayers, 'mousemove', function (e) {
					if (that.rectangle)
						_mapLayers.removeOverlay(that.rectangle)
					that.endPoi = e.latlng;
					that.rectangle = Tools.drawCircles(that.startPoi, that.endPoi, _mapLayers, _style);
				});
			});
			that.circleMouseup = CEvent.addListener(_mapLayers, 'mouseup', function (e) {
				that.rectangle;
				CEvent.removeListener(that.circleMouseup), CEvent.removeListener(that.circleMousedown), CEvent.removeListener(that.circleMousemove);
				_mapLayers.dragging.enable();
				if (callback)
					callback(that.rectangle._latlng, that.rectangle);
			});
		},
		Tools.drawCircles = function (startLatLng, endlatLng, _mapLayers, _style) {
			var opts = {
				color: '#c45366',
				weight: 2,
				opacity: 0.9,
				fill: true,
				fillColor: '#009900',
				fillOpacity: 0.4
			};
			if (_style)
				opts = _style;
			feature = mapLayers.drawCircle(startLatLng, endlatLng, opts);
			return feature;
		},
		Tools.removeCircles = function (_mapLayers, _layer) {
			_mapLayers.removeOverlay(_layer);
		},
		Tools.draggingEnable = function (_mapLayers) {
			var that = this;
			_mapLayers.dragging.enable();
			CEvent.removeListener(that.rectangleMouseup), CEvent.removeListener(that.rectangleMousedown), CEvent.removeListener(that.rectangleMousemove);
			CEvent.removeListener(that.circleMouseup), CEvent.removeListener(that.circleMousedown), CEvent.removeListener(that.circleMousemove);
			CEvent.removeListener(that.mouseup), CEvent.removeListener(that.lineMousemove), CEvent.removeListener(that.singlerightclick);
		}
	Tools.EventClick = function () {}
	_tools.Tools = Tools;
})(window);